import { useNavigate } from "react-router-dom";

import SmartImage from "../../../../../components/SmartImage";
import { getLabel } from "../../../../../hooks/use-labels";
import { OrderCardSkeleton } from "../OrderSkeletons";
import { badgeForStatus } from "../../../../../features/orders/orderStatus";
import { formatMoney } from "../../../../../features/orders/format";
import {
  formatOrderNumber,
  splitNote,
  supplierChipLabel,
} from "../order-list-utils";

const SupplierAvatar = ({ supplier }) =>
  supplier.logoUrl ? (
    <SmartImage
      src={`${supplier.logoUrl}?size=xs`}
      alt=""
      width="38px"
      height="38px"
      radius="10px"
    />
  ) : (
    <span className="ord-avatar ord-avatar-initials">{supplier.initials}</span>
  );

const OrderCard = ({ row, onOpen }) => {
  const badge = badgeForStatus(row.status);

  return (
    <li className="ord-card">
      <button type="button" className="ord-card-button" onClick={onOpen}>
        <span className="ord-card-head">
          <span className="ord-card-number">
            {formatOrderNumber(row.orderNumber)}
          </span>

          {row.isMaster && (
            <span className="ord-chip">{supplierChipLabel(row)}</span>
          )}

          {badge && (
            <span className={`ord-status ord-status-${badge.tone}`}>
              {badge.label}
            </span>
          )}
        </span>

        <span className="ord-card-rule" />

        {row.isMaster ? (
          <span className="ord-suppliers">
            <span className="ord-suppliers-label">Supplier(s)</span>

            {row.suppliers.map((supplier) => (
              <span className="ord-supplier" key={supplier.orderId}>
                <SupplierAvatar supplier={supplier} />

                <span className="ord-supplier-name">{supplier.name}</span>

                <span className="ord-supplier-num">#{supplier.orderNumber}</span>
              </span>
            ))}

            {row.missingCount > 0 && (
              <span className="ord-split-note">{splitNote(row.missingCount)}</span>
            )}
          </span>
        ) : (
          <span className="ord-supplier">
            <SupplierAvatar supplier={row.supplier} />

            <span className="ord-supplier-name">{row.supplier.name}</span>
          </span>
        )}

        <span className="ord-facts">
          <span className="ord-fact">
            <span className="ord-fact-label">
              {getLabel("orderDateTimeLabel")}
            </span>
            <span className="ord-fact-value">
              {row.placedDate} | {row.placedTime}
            </span>
          </span>

          {row.deliveryTypeLabel && (
            <span className="ord-fact">
              <span className="ord-fact-label">
                {getLabel("deliveryTypeLabel")}
              </span>
              <span className="ord-fact-value">
                {getLabel(row.deliveryTypeCode) || row.deliveryTypeLabel}
              </span>
            </span>
          )}

          <span className="ord-fact">
            <span className="ord-fact-label">
              {getLabel("deliveryDateTimeLabel")}
            </span>
            <span className="ord-fact-value">{row.deliveryLabel}</span>
          </span>

          <span className="ord-fact ord-fact-amount">
            <span className="ord-fact-label">
              {row.isMaster
                ? "Paid Amount (all suppliers)"
                : getLabel("paidAmountLabel")}
            </span>
            <span className="ord-fact-value">{formatMoney(row.paidAmount)}</span>
          </span>
        </span>
      </button>
    </li>
  );
};

const OrdersListContent = ({ rows, tab, loadingMore }) => {
  const navigate = useNavigate();

  const moveToOrderDetail = (id) => {
    navigate(`/my-orders/detail?id=${id}`, {
      state: { link: { path: "/my-orders", previousState: { paramTab: tab } } },
    });
  };

  return (
    <ul className="ord-list">
      {rows.map((row) => (
        <OrderCard
          key={row.key}
          row={row}
          onOpen={() => moveToOrderDetail(row.id)}
        />
      ))}

      {loadingMore &&
        Array.from({ length: 6 }, (unused, index) => (
          <OrderCardSkeleton key={`skeleton-${index}`} />
        ))}
    </ul>
  );
};

export default OrdersListContent;
